import { render, staticRenderFns } from "./BCE.vue?vue&type=template&id=97fe32d0&"
import script from "./BCE.vue?vue&type=script&lang=js&"
export * from "./BCE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports